module.exports = __webpack_public_path__ + "static/dashboard1-1653bce58b6310f79efa543db412f882.svg";